import { useEffect, useState } from "react";
import CosmeticCard from "../Cosmetic/display/CosmeticCard";

export default function CollectionRow({
  collections,
  collection,
  playerItem,
  onClick,
  isOpen,
}) {
  const [owned, setOwned] = useState(0);
  const [filter, setFilter] = useState("both");

  useEffect(() => {
    const count = collections[collection].filter((item) =>
      (playerItem[item.type] || []).includes(item.id)
    ).length;

    setOwned(count);
  }, [collections, collection, playerItem]);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredItems = collections[collection].filter((item) => {
    const isOwned = (playerItem[item.type] || []).includes(item.id);

    if (filter === "owned") return isOwned;
    if (filter === "unowned") return !isOwned;
    return true;
  });

  return (
    <div>
      <div className="black-dropdown black-zeqa-dropdown">
        <div
          className="black-dropdown-toggle black-zeqa-dropdown-toggle"
          onClick={onClick}
        >
          <div className="black-select-toggle-title-wrapper">
            <h6 style={{ marginBottom: 16 }}>{collection}</h6>
            <h3
              style={{
                marginBottom: 23,
                fontSize: 14,
                ...(window.innerWidth <= 479 && { marginBottom: 10 }),
              }}
            >
              [{owned}/{collections[collection].length}]
            </h3>
          </div>
        </div>
        <div
          className={`dropdown-content-wrap zeqa-dropdown-list ${
            isOpen ? "open" : ""
          }`}
        >
          {isOpen && (
            <div style={{ padding: 20 }}>
              <div className="dropdown zeqa-dropdown">
                <div className="dropdown-toggle zeqa-dropdown-toggle">
                  <select
                    className="select-toggle-title-wrapper"
                    value={filter}
                    onChange={handleFilterChange}
                  >
                    <option value="both">Complete Set</option>
                    <option value="owned">Show Owned</option>
                    <option value="unowned">Show Unowned</option>
                  </select>
                </div>
              </div>
              <div className="cosmetic_display collection_row">
                {filteredItems.map((item, idx) => {
                  const ownedThisOne = (playerItem[item.type] || []).includes(
                    item.id
                  );
                  return (
                    <CosmeticCard
                      key={idx}
                      item={item}
                      nameColor={ownedThisOne ? "#00ff73" : "gray"}
                    />
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
